import React, { useContext, useState } from "react";
import "./Section_Header_Bar.css";
import CircularProgress from "@mui/joy/CircularProgress";
import White_Btn from "../common_btn/white_btn/White_Btn";
import Orange_White_Border_Btn from "../common_btn/orange_white_border_btn/Orange_White_Border_Btn";
import { useNavigate } from "react-router-dom";
import { Modal } from "react-bootstrap";
import Verification_Steps_Modal from "../common_modal/verification_steps_modal/Verification_Steps_Modal";
import { Context } from "../../../utils/context";

const Section_Header_Bar = () => {
  const navigate = useNavigate();
  const [showModal, setShowModal] = useState(false);

  const { userdata, getuserData, signin } = useContext(Context);

  const isProfileAccepted = userdata?.accept_or_reject === true;
  const progressValue = isProfileAccepted ? 100 : 80;

  return (
    <section className="section-header-bar">
      <div className="header-card">
        <div className="header-grid">
          {/* Left - Progress + Greeting */}
          <div className="left-section">
            <div className="progress-wrapper">
              <CircularProgress
                size="lg"
                determinate
                value={progressValue}
                color={isProfileAccepted ? "success" : "primary"}
                variant="soft"
                thickness={4}
              >
                <span className="progress-text">{progressValue}%</span>
              </CircularProgress>
            </div>

            <div className="greeting-content">
              <h2 className="greeting">
                Hello, <span className="user-name">{userdata?.first_name || "User"}</span>
              </h2>
              <p className="status-message">
                {isProfileAccepted
                  ? "Your profile is fully verified and ready!"
                  : "Complete your profile to unlock deposits & trading."}
              </p>
            </div>
          </div>

          {/* Right - Action Buttons */}
          <div className="right-section">
            <div className="action-buttons">
              <White_Btn
                btn_name="Learn More"
                onClick={() => navigate("/about-profile")}
                className="learn-btn"
              />

              {!isProfileAccepted && (
                <Orange_White_Border_Btn
                  btn_name="Complete Profile"
                  onClick={() => setShowModal(true)}
                  className="complete-btn"
                />
              )}
            </div>
          </div>
        </div>
      </div>

      <Verification_Steps_Modal
        show={showModal}
        onHide={() => setShowModal(false)}
      />
    </section>
  );
};

export default Section_Header_Bar;